import { articles } from "@/mocks/gossip";
import ArticleCard from "@/components/feature/ArticleCard";
import SectionHeading from "@/components/feature/SectionHeading";
import Reveal from "@/components/base/Reveal";

const feed = [...articles].sort((a, b) => (a.date < b.date ? 1 : -1)).slice(0, 6);

export default function FeaturedFeed() {
  return (
    <section className="mx-auto w-full px-4 py-16 md:px-6 md:py-20 lg:px-10">
      <SectionHeading
        eyebrow="EDITOR'S PICKS"
        title="编辑部精选"
        desc="经过交叉核实、补充了背景信息的完整稿件，适合慢慢读完。"
        linkText="浏览全部稿件"
        linkTo="/hot"
      />

      <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {feed.map((article, index) => (
          <Reveal key={article.id} delay={(index % 3) * 90} className="h-full">
            <ArticleCard article={article} />
          </Reveal>
        ))}
      </div>
    </section>
  );
}